"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertGrLocaleForNumeral = exports.convertGrLocaleToBcpOrFallbackToDefault = exports.convertGrLocaleToBcpLocale = void 0;
var grLocaleToBcpLocaleMap = {
  br: 'pt-br',
  da: 'da',
  de: 'de',
  en: 'en',
  es: 'es-es',
  fr: 'fr',
  gb: 'en-gb',
  hu: 'hu',
  id: 'id',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  ms: 'ms',
  nl: 'nl',
  no: 'no',
  pl: 'pl',
  pt: 'pt',
  ro: 'ro',
  ru: 'ru',
  sv: 'sv',
  th: 'th',
  tr: 'tr',
  vi: 'vi',
  zh: 'zh-cn',
  ie: 'en-ie',
  mx: 'es-mx'
};
var numeralLocales = {
  zh: 'chs',
  br: 'pt-br',
  da: 'da-dk',
  de: 'de',
  en: 'en',
  es: 'es-es',
  fr: 'fr',
  gb: 'en-gb',
  hu: 'hu',
  it: 'it',
  ja: 'ja',
  nl: 'nl-nl',
  no: 'no',
  pl: 'pl',
  pt: 'pt-pt',
  ru: 'ru',
  th: 'th',
  tr: 'tr',
  vi: 'vi',
  mx: 'es-es'
};
function convertGrLocaleToBcpLocale(grLocale) {
  return grLocaleToBcpLocaleMap[grLocale] || grLocale;
}
exports.convertGrLocaleToBcpLocale = convertGrLocaleToBcpLocale;
function convertGrLocaleToBcpOrFallbackToDefault(grLocale) {
  return grLocaleToBcpLocaleMap[grLocale] || grLocaleToBcpLocaleMap.en;
}
exports.convertGrLocaleToBcpOrFallbackToDefault = convertGrLocaleToBcpOrFallbackToDefault;
function convertGrLocaleForNumeral(grLocale) {
  return numeralLocales[grLocale] || numeralLocales.en;
}
exports.convertGrLocaleForNumeral = convertGrLocaleForNumeral;